import { gql } from 'apollo-boost'





export const REDEEM_CODE = gql`
mutation($code: String,$moreCodes: String){
    redeemSaastraunaticsCode(code:$code, moreCodes:$moreCodes)
}`